import { useQuery } from "@tanstack/react-query";
import { apiCall } from "@/lib/api";

export type NotifSeverity = "info" | "warning" | "error";
export type NotifTipo =
  | "pago"
  | "promesa_hoy"
  | "promesa_vencida"
  | "job_error"
  | "suspension_hoy";

export type NotificationItem = {
  id: string;
  tipo: NotifTipo;
  severity: NotifSeverity;
  title: string;
  description: string;
  link: string;
  occurred_at: string;
};

export type NotificationsResponse = {
  items: NotificationItem[];
  total: number;
  by_severity: { info: number; warning: number; error: number };
};

/** dev121 — feed de notificaciones recientes. Polling cada 30s. */
export function useNotifications(opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["notifications", "recent"],
    queryFn: () =>
      apiCall<NotificationsResponse>("get", "/api/v1/notifications/recent"),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    enabled: opts.enabled ?? true,
  });
}
